export default function RaShow(theme): object {
  return {
    RaShow: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.spacing(2),
          boxShadow: theme.shadows[2],
        },
      },
    },
  }
}
